import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import DateHelper from 'src/app/helpers/date-helper';
import LoggedAction from 'src/app/model/logged-action';
import { LoadingService } from '../../loading.service';
import { SnackService } from '../../snack.service';
import { Observable } from 'rxjs';
import { _post } from '../../base.service';

@Injectable({
  providedIn: 'root',
})
export class ToggleSubProjectApprovalControllerRequestService {
  private static BASE_URL = '/immo/toggleSubProjectApproval';
  private readonly post: <T>(
    path: string,
    body: null,
    deserialize: (response: any) => T
  ) => Observable<T>;

  private readonly deserializer = (
    res: ToggleSubProjectApprovalRawResponse
  ) => {
    return {
      newApprovalValue: res.newApprovalValue,
      productApprovalDate:
        res.productApprovalDate == null
          ? null
          : DateHelper.parseDate(res.productApprovalDate),
      approvedRegistration: res.approvedRegistration,
    };
  };

  constructor(
    http: HttpClient,
    snackService: SnackService,
    loadingService: LoadingService,
    router: Router
  ) {
    const requestServices = {
      http,
      loadingService,
      router,
      snackService,
    };
    this.post = _post(
      ToggleSubProjectApprovalControllerRequestService.BASE_URL,
      requestServices
    );
  }

  public toggleSubProjectApproval(
    subProjectId: number
  ): Promise<ToggleSubProjectApprovalResponse> {
    return this.post(`/${subProjectId}`, null, this.deserializer).toPromise();
  }
}

interface ToggleSubProjectApprovalRawResponse {
  newApprovalValue: boolean;

  productApprovalDate: string;

  approvedRegistration: LoggedAction;
}

export interface ToggleSubProjectApprovalResponse {
  newApprovalValue: boolean;

  productApprovalDate: Date;

  approvedRegistration: LoggedAction;
}
